import { HOUR_IN_MILLISECONDS } from 'config';
import {
  BreakingScheduleDto,
  BreakingTestDto,
  PourDto,
  useGetBreakingScheduleQuery,
  usePourQuery
} from 'providers/api';
import { useGetBreakingTestQuery } from 'providers/api/useBreakingTests';
import { UseQueryResult } from 'react-query';
import { CylinderBreakingTestUpdateParams } from './constants';

export type CylinderBreakingTestQueries = [
  UseQueryResult<PourDto, unknown>,
  UseQueryResult<BreakingScheduleDto, unknown>,
  UseQueryResult<BreakingTestDto, unknown>,
];

const useCylinderBreakingTestQueries = (params: CylinderBreakingTestUpdateParams): CylinderBreakingTestQueries => {
  const pourQuery = usePourQuery(params.pourId, { staleTime: HOUR_IN_MILLISECONDS });
  const breakingScheduleQuery = useGetBreakingScheduleQuery(params.breakingScheduleId, { staleTime: HOUR_IN_MILLISECONDS });
  const breakingTestQuery = useGetBreakingTestQuery(params.breakingTestId, { staleTime: HOUR_IN_MILLISECONDS });
  return [pourQuery, breakingScheduleQuery, breakingTestQuery];
};

export default useCylinderBreakingTestQueries;
